<template>
    <select2 :value="value"
             @input="$emit('input', $event)"
             :plugin-options="select2Options"
             :dropdown-parent-selector="dropdownParentSelector"
             :is-ajax="true"
             class="form-control"></select2>
</template>

<script>
    const SearchUsersComponent = {
        props: ["dropdownParentSelector", "value", "roleId"],
        data() {
            return {
                select2Options: {
                    minimumInputLength: 2,
                    allowClear: true,
                    width: "100%",
                    placeholder: this.$t("usersManagement.userNameOrEmail"),
                    ajax: {
                        url: "/api/UserManagement/SearchUsers",
                        delay: 250,
                        data: params => (this.getRequest(params)),
                        processResults: data => {
                            return {
                                results: data.map(item => ({
                                    id: item.id,
                                    text: item.userName + " (" + item.email + ")"
                                }))
                            };
                        }
                    }
                }
            };
        },

        methods: {
            getRequest(params) {
                const request = {
                    term: params.term
                };

                if (this.roleId) {
                    request.roleId = this.roleId;
                }

                return request;
            }
        }
    };

    export default SearchUsersComponent;
</script>